import './HomePage.css'
import { Tools } from '../Services/Tools';
import { Row, Col } from 'react-bootstrap';
import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import ToolCard from './ToolCard';
import { getCategoryRoute, getToolRoute, getToolDisplayName } from './toolRoutes';
import { readFavoriteTools } from '../Services/toolFavorites';


function HomePage() {
    const tools = Tools;
    const navigate = useNavigate();
    const [favoriteTools, setFavoriteTools] = useState([]);

    useEffect(() => {
        setFavoriteTools(readFavoriteTools());
    }, []);


    const toggleFavorite = (tool) => {
        const newFavorites = favoriteTools.filter(f => f.toolName !== tool.toolName);
        setFavoriteTools(newFavorites);
        localStorage.setItem('favoriteTools', JSON.stringify(newFavorites));
    };
    const handleCategoryClick = (tool) => {
        
        const route = getCategoryRoute(tool.CategoryName);
        navigate( route, {
        state: {
            categoryName: tool.CategoryName,
            tools: tool.SubCategory,
            icon:tool.Icon
        }
    });
};

    const handleToolClick = (tool) => {
        const route = getToolRoute(tool.toolName);
        const category = Tools.find(item => item.SubCategory.some(entry => entry.SubCategory === tool.toolName));
        navigate(route, { state: { categoryName: category?.CategoryName, toolName: tool.toolName } });
    };

    return (
        <>
            <Col>
                <Row>
                    <div className="Introduction-homepage">
                        <span className='Heading'>Welcome to COBYGO</span>
                        <p className='Paragrapgh'>Your all-in-one developer toolkit — with 80+ utilities for JSON, encoding, hashing, diffing, and more.
                            Pick a tool from the sidebar or search above to get started.</p>
                    </div>
                </Row>
                <Row className='Alltools'>
                    <Col>
                        <div className='AlltoolsHeading'>
                            <img src='/Favourites.svg' alt='' />
                            <span >Favourites</span>
                        </div>
                        <div className='Alltoolslist'>
                            {favoriteTools.map((tool) => (
                                <ToolCard
                                    key={tool.toolName}
                                    className='favtool'
                                    icon={tool.Iconpath}
                                    title={getToolDisplayName(tool.toolName)}
                                    onClick={() => handleToolClick(tool)}
                                    actions={
                                        <button className='favBtn' onClick={(e) => {
                                            e.stopPropagation();
                                            toggleFavorite(tool);
                                        }}>
                                            <img src='/FavouriteSolid.svg' alt='Remove from favorites' />
                                        </button>
                                    }
                                />
                            ))}

                        </div>
                    </Col>
                </Row>
                <Row className='Alltools'>
                    <Col>
                        <div className='AlltoolsHeading'>
                            <img src='/AllCategories.svg' alt='' />
                            <span >All Categories</span>
                        </div>
                        <div className='Alltoolslist'>
                            {tools.map((tool) => (
                                <ToolCard
                                    key={tool.CategoryName}
                                    icon={tool.Icon}
                                    title={tool.CategoryName}
                                    meta={<div className="tool-count">{tool.SubCategory.length} Tools</div>}
                                    onClick={() => handleCategoryClick(tool)}
                                />
                            ))}
                        </div>
                    </Col>
                </Row>
            </Col>
        </>
    )
}

export default HomePage;
